import { createSvg } from '../createSvg';
var ArrowDown = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return <g id={'contour'}>
        <path d='M18.0699 14.43L11.9999 20.5L5.92993 14.43' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M12 3.5V20.33' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
    </g>;
};
export default createSvg(ArrowDown, 'arrow-down');
